import { AccessoriesProps } from '../types/states';
import apiClient from './axios';

export async function getAccessoriesApi(order_id: number): Promise<string> {
  return order_id
    ? apiClient
        .get(`/orders/${order_id}/accessories/`)
        .then((response) => {
          return response.data;
        })
        .catch(() => {
          return false;
        })
    : {};
}

export async function addaccessoriesApi(
  order_id: number,
  data: Record<string, never>
): Promise<{ data: AccessoriesProps }> {
  return apiClient.post(`/orders/${order_id}/accessories/`, data);
}

export async function deleteAccessoriesApi(order_id: number, accId: number): Promise<string> {
  return apiClient
    .delete(`/orders/${order_id}/accessories/${accId}`)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return false;
    });
}
